{
  "hub": {
    "title": "All tasks",
    "description": "Every task in this organization: who works on it, where it stands and what needs you.",
    "new": "New task",
    "openBoard": "Board",
    "search": "Search tasks…",
    "live": "Live",
    "liveHint": "Changes by agents and teammates appear instantly.",
    "offline": "Reconnecting",
    "offlineHint": "Live updates are paused; the list refreshes every few seconds.",
    "attention_one": "{{count}} task needs you",
    "attention_other": "{{count}} tasks need you",
    "attentionWaiting_one": "{{count}} waiting for input",
    "attentionWaiting_other": "{{count}} waiting for input",
    "attentionReview_one": "{{count}} to review",
    "attentionReview_other": "{{count}} to review",
    "columns": {
      "task": "Task",
      "status": "Status",
      "priority": "Priority",
      "assignee": "Assignee",
      "progress": "Progress",
      "due": "Due",
      "updated": "Updated"
    },
    "filters": {
      "allStatuses": "All statuses",
      "allProjects": "All projects",
      "standalone": "No project",
      "allAssignees": "Anyone",
      "allPriorities": "Any priority",
      "sort": "Sort",
      "sortBy": "Sort: {{order}}",
      "clear": "Clear filters"
    },
    "empty": {
      "title": "No tasks yet",
      "description": "Create a task and hand it to an agent, a team or the shared pool."
    },
    "emptyFiltered": {
      "title": "No matching tasks",
      "description": "No tasks match these filters. Try another search or clear the filters."
    }
  },
  "board": {
    "title": "Board",
    "description": "Drag tasks between lanes to move them through the workflow, or reorder them by priority.",
    "openList": "List",
    "laneEmpty": "Nothing here",
    "needsInput": "Needs input",
    "working": "Working",
    "showAll_one": "Show all {{count}}",
    "showAll_other": "Show all {{count}}",
    "showRecent": "Show recent only",
    "notAllowed": "A task can't move from {{from}} to {{to}}.",
    "moveRejected": "The task could not be moved there (check its assignee, inputs and dependencies).",
    "truncated": "Showing {{shown}} of {{total}} tasks — narrow the filters to see the rest.",
    "a11y": {
      "instructions": "Press space to pick up a task. Use the arrow keys to move it, space to drop it, escape to cancel. Press enter to open it.",
      "picked": "Picked up {{title}}.",
      "over": "{{title}} is over {{lane}}.",
      "dropped": "{{title}} dropped in {{lane}}.",
      "cancelled": "Move cancelled."
    }
  },
  "task": {
    "detailTitle": "Task",
    "detailDescription": "Task details, conversation and activity",
    "backToList": "All tasks",
    "notFound": "Task not found",
    "waitingOn_one": "Waiting on {{count}} task",
    "waitingOn_other": "Waiting on {{count}} tasks",
    "status": {
      "backlog": "Backlog",
      "todo": "To do",
      "progress": "In progress",
      "review": "In review",
      "blocked": "Blocked",
      "done": "Done",
      "waiting": "Waiting for input",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "priority": {
      "urgent": "Urgent",
      "high": "High",
      "normal": "Normal",
      "low": "Low"
    },
    "closure": {
      "success": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "order": {
      "sort_order": "Manual order",
      "updated_at": "Recently updated",
      "created_at": "Newest",
      "due_at": "Due date",
      "priority": "Priority"
    },
    "assignee": {
      "unassigned": "Unassigned",
      "pool": "Pool",
      "poolHint": "Any available agent picks it up",
      "agent": "Agent",
      "team": "Team"
    },
    "fields": {
      "title": "Title",
      "description": "Description",
      "descriptionPlaceholder": "What needs to be done? Markdown is supported.",
      "expectedOutput": "Expected output",
      "expectedOutputPlaceholder": "What does a good result look like?",
      "project": "Project",
      "noProject": "No project",
      "priority": "Priority",
      "assignee": "Assignee",
      "due": "Due",
      "status": "Status",
      "progress": "Progress",
      "labels": "Labels",
      "labelsPlaceholder": "Add a label…",
      "requiredInputs": "Required inputs",
      "requiredInputsHint": "The task waits in the backlog until a person fills these in.",
      "requiredInputsPlaceholder": "e.g. customer_email",
      "autoStart": "Auto-start",
      "autoStartHint": "Dispatch to the assignee as soon as the task is ready.",
      "autoStartOn": "Starts when ready",
      "autoStartOff": "Manual start",
      "createdBy": "Created by",
      "created": "Created",
      "updated": "Updated",
      "started": "Started",
      "completed": "Closed"
    },
    "create": {
      "title": "New task",
      "description": "Describe the work and choose who does it. Agents begin once the task is ready and started.",
      "submit": "Create task"
    },
    "actions": {
      "open": "Open",
      "openPage": "Open as page",
      "start": "Start",
      "retry": "Retry",
      "markReady": "Mark ready",
      "moveTo": "Move to",
      "complete": "Mark as done",
      "cancel": "Cancel task",
      "delete": "Delete task",
      "editTitle": "Edit title",
      "more": "Actions for {{title}}"
    },
    "confirm": {
      "completeTitle": "Mark this task as done?",
      "completeDescription": "“{{title}}” is closed as completed. Any agent still working on it is stopped.",
      "blockTitle": "Block this task?",
      "blockDescription": "Blocked tasks stop running until they are unblocked. Say what is in the way.",
      "blockReason": "Reason (optional)",
      "cancelTitle": "Cancel this task?",
      "cancelDescription": "“{{title}}” is closed as cancelled and any running agent is stopped.",
      "keep": "Keep task",
      "deleteTitle": "Delete this task?",
      "deleteDescription": "“{{title}}” and its history are removed permanently. This cannot be undone."
    },
    "blockers": {
      "unassigned": "Assign it to start",
      "inputs": "Missing inputs: {{fields}}",
      "dependencies_one": "Waits for {{count}} unfinished task",
      "dependencies_other": "Waits for {{count}} unfinished tasks"
    },
    "human": {
      "approvalTitle": "Approval needed",
      "approvalBody": "The agent wants to run {{tool}} and needs your go-ahead.",
      "aTool": "a tool",
      "notePlaceholder": "Optional note for the agent…",
      "approve": "Approve",
      "deny": "Deny",
      "approved": "Approved",
      "denied": "Denied",
      "questionTitle": "The agent has a question",
      "options": "Suggested answers",
      "answerPlaceholder": "Your answer…",
      "answerHint": "The agent continues as soon as you answer. Ctrl/⌘ + Enter to send.",
      "sendAnswer": "Send answer"
    },
    "review": {
      "title": "Ready for review",
      "description": "Accept the result to close the task, approve so the work continues, or ask for changes.",
      "placeholder": "Feedback or instructions (optional)…",
      "accept": "Accept & close",
      "approveContinue": "Approve & continue",
      "requestChanges": "Request changes"
    },
    "followUp": {
      "placeholder": "Ask the agent for a follow-up…",
      "hint": "Reopens the task and continues the agent's conversation.",
      "send": "Send follow-up"
    },
    "inputs": {
      "title": "Inputs",
      "missing": "Fill in the required inputs to make the task ready: {{fields}}",
      "save": "Save inputs"
    },
    "checklist": {
      "title": "Checklist",
      "progress": "{{done}} of {{total}} done",
      "add": "Add an item…",
      "remove": "Remove “{{item}}”"
    },
    "live": {
      "title": "Live",
      "connecting": "Connecting to the agent…",
      "working": "The agent is working…",
      "finished": "Run finished",
      "reasoning": "Reasoning",
      "noOutput": "No output yet.",
      "openRun": "View run"
    },
    "failure": {
      "title": "The last run failed",
      "hint": "Fix the cause — for example hand the task to another assignee — and retry."
    },
    "sections": {
      "result": "Result",
      "dependencies": "Depends on",
      "dependents": "Blocks",
      "properties": "Properties"
    },
    "dependencies": {
      "add": "Add a task to wait for…",
      "remove": "Stop waiting for “{{title}}”"
    },
    "empty": {
      "description": "Add a description…",
      "expectedOutput": "Describe the expected result…"
    },
    "output": {
      "title": "Project data",
      "description": "Store a value in the shared data of {{project}} so other tasks and agents can use it.",
      "key": "Key",
      "keyPlaceholder": "e.g. summary",
      "value": "Value",
      "save": "Save to project"
    },
    "timeline": {
      "conversation": "Conversation",
      "activity": "Activity",
      "noConversation": "No messages yet",
      "noConversationHint": "Comments, agent updates and questions appear here.",
      "noActivity": "No activity yet.",
      "requested": "asked",
      "answered": "answered",
      "followUp": "follow-up",
      "workflowNote": "workflow note",
      "you": "Someone"
    },
    "comment": {
      "placeholder": "Write a comment…",
      "hint": "Visible to people and agents on this task.",
      "post": "Comment"
    },
    "events": {
      "created": "Created the task",
      "assigned": "Assigned to {{assignee}}",
      "statusChanged": "Moved from {{from}} to {{to}}",
      "retried": "Retried the task",
      "reopened": "Reopened the task",
      "started": "Started the task",
      "approved": "Approved",
      "inputSubmitted": "Provided inputs: {{keys}}",
      "blocked": "Blocked the task",
      "blockedReason": "Blocked: {{reason}}",
      "unblocked": "Unblocked the task",
      "progress": "Progress {{percent}}%",
      "reordered": "Reordered in {{status}}",
      "checklistChecked": "Checked “{{item}}”",
      "checklistUnchecked": "Unchecked “{{item}}”",
      "checklistUpdated": "Updated the checklist",
      "approvalRequested": "Asked to approve {{tool}}"
    },
    "toast": {
      "created": "Task “{{title}}” created",
      "deleted": "Task “{{title}}” deleted",
      "inputsSaved": "Inputs saved",
      "started": "Task started",
      "retried": "Task restarted",
      "approved": "Approved — the work continues",
      "messageSent": "Sent to the agent",
      "cancelled": "Task cancelled",
      "outputSaved": "Saved “{{key}}” to the project"
    }
  },
  "projects": {
    "title": "Projects",
    "description": "Group tasks, knowledge, files and rules, and let an orchestrator drive the work.",
    "detailTitle": "Project",
    "new": "New project",
    "search": "Search projects…",
    "showArchived": "Show archived",
    "noDescription": "No description",
    "backToList": "Projects",
    "moreActions": "More actions",
    "progress": "Progress",
    "openOfTotal": "{{open}} open of {{total}}",
    "unassigned": "Unassigned",
    "on": "On",
    "off": "Off",
    "archive": "Archive",
    "restore": "Restore",
    "delete": "Delete project",
    "archiveTitle": "Archive “{{name}}”?",
    "archiveDescription": "The project is hidden from the default list. Its tasks, knowledge and data are kept and you can restore it at any time.",
    "deleteTitle": "Delete “{{name}}”?",
    "deleteDescription_one": "This permanently deletes the project, its {{count}} task, knowledge, files, data and history, and stops anything still running. This cannot be undone.",
    "deleteDescription_other": "This permanently deletes the project, its {{count}} tasks, knowledge, files, data and history, and stops anything still running. This cannot be undone.",
    "empty": {
      "title": "No projects yet",
      "description": "Create a project to group related tasks and give agents shared knowledge, files and rules."
    },
    "columns": {
      "project": "Project",
      "status": "Status",
      "tasks": "Tasks",
      "orchestrator": "Orchestrator",
      "updated": "Updated"
    },
    "status": {
      "active": "Active",
      "completed": "Completed",
      "archived": "Archived"
    },
    "taskStatus": {
      "backlog": "Backlog",
      "todo": "To do",
      "progress": "In progress",
      "waiting": "Waiting",
      "review": "Review",
      "blocked": "Blocked",
      "done": "Done",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "priority": {
      "low": "Low",
      "normal": "Normal",
      "high": "High",
      "urgent": "Urgent"
    },
    "toast": {
      "created": "Project “{{name}}” created",
      "saved": "Project “{{name}}” saved",
      "archived": "Project “{{name}}” archived",
      "deleted": "Project “{{name}}” deleted"
    },
    "form": {
      "newTitle": "New project",
      "editTitle": "Edit project",
      "description": "Projects bundle tasks with the knowledge, files and rules agents need to work on them.",
      "create": "Create project",
      "name": "Name",
      "namePlaceholder": "e.g. Website relaunch",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "What is this project about?",
      "color": "Colour",
      "status": "Status",
      "statusHint": "Completed projects stay in the list; archived projects are hidden by default.",
      "autoRun": "Auto-start follow-up tasks",
      "autoRunHint": "When an agent finishes and creates a follow-up task, start it automatically. Ignored while the orchestrator is enabled.",
      "maxAutoResume": "Max automatic starts in a row",
      "maxAutoResumeHint": "Follow-up tasks that may auto-start before a human has to step in.",
      "maxFailures": "Failures before escalation",
      "maxFailuresHint": "Consecutive failed tasks before the orchestrator asks a human for help."
    },
    "tabs": {
      "overview": "Overview",
      "tasks": "Tasks",
      "orchestrator": "Orchestrator",
      "knowledge": "Knowledge",
      "files": "Files",
      "rules": "Rules",
      "data": "Data",
      "activity": "Activity"
    },
    "stats": {
      "tasks": "Tasks",
      "open_one": "{{count}} open",
      "open_other": "{{count}} open",
      "completion": "Completed",
      "documents": "Knowledge docs",
      "folders_one": "{{count}} folder",
      "folders_other": "{{count}} folders",
      "files": "Files"
    },
    "overview": {
      "automation": "Automation",
      "openOrchestrator": "Open orchestrator",
      "orchestrator": "Orchestrator",
      "goal": "Goal",
      "noGoal": "No goal set",
      "lastPass": "Last pass",
      "autoRun": "Auto-start follow-ups",
      "autoResumes": "Automatic starts",
      "failureStreak": "Failed tasks in a row",
      "usedOf": "{{used}} of {{max}}",
      "created": "Created",
      "recentActivity": "Recent activity",
      "viewAll": "View all"
    },
    "export": {
      "title": "Export project log",
      "hint": "Download the full audit trail as JSON: tasks with their timelines, agent runs and tool calls, orchestrator passes, knowledge, data, activity and benchmarks.",
      "download": "Download JSON export",
      "done": "Project export downloaded"
    },
    "tasks": {
      "search": "Search tasks…",
      "openBoard": "Board",
      "openAll": "All tasks",
      "empty": "No tasks in this project yet",
      "emptyHint": "Create one with New task, or let the orchestrator plan them.",
      "moveUp": "Move up",
      "moveDown": "Move down"
    },
    "taskColumns": {
      "title": "Task",
      "status": "Status",
      "priority": "Priority",
      "assignee": "Assignee",
      "updated": "Updated"
    },
    "activity": {
      "empty": "No activity yet",
      "emptyHint": "Changes by people, agents and the orchestrator show up here.",
      "loadOlder": "Load older",
      "kinds": {
        "projectCreated": "Project created: {{name}}",
        "projectUpdated": "Project updated: {{fields}}",
        "projectArchived": "Project archived",
        "taskCreated": "Task #{{number}} created: {{title}}",
        "taskUpdate": "Task #{{number}}: {{text}}",
        "fileUploaded": "File uploaded: {{name}}",
        "fileDeleted": "File deleted: {{name}}",
        "docUpdated": "Knowledge doc updated: {{location}}",
        "docDeleted": "Knowledge doc deleted: {{location}}",
        "folderCreated": "Knowledge folder created: {{folder}}",
        "ruleAdded": "Project rule added: {{text}}",
        "autoResumeCap": "Auto-resume cap reached ({{max}}); remaining tasks await a human start.",
        "orchestratorReset": "Orchestrator reset by a human (lock cleared).",
        "orchestratorPass": "Orchestrator pass: {{summary}}",
        "projectDone": "Orchestrator marked the project done. {{summary}}",
        "statusSet": "Orchestrator set project status to {{status}}.",
        "needsHuman": "Orchestrator needs the human: {{message}}",
        "escalated": "Escalated to human: {{failures}} consecutive task failures (cap {{cap}}). Last failure: task #{{number}} “{{title}}”."
      }
    },
    "rules": {
      "title": "Project rules",
      "hint": "Short directives added to the instructions of every agent working on this project, e.g. “Write all documents in Dutch”.",
      "placeholder": "Add a rule…",
      "add": "Add rule",
      "added": "Rule added",
      "deleted": "Rule deleted",
      "editLabel": "Rule text",
      "toggle": "Rule enabled",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "delete": "Delete rule",
      "deleteTitle": "Delete this rule?",
      "empty": "No rules yet",
      "emptyHint": "Rules keep agents consistent across every task in the project."
    },
    "data": {
      "hint": "A shared key–value store. Agents read and write it while they work; you can edit it too.",
      "search": "Search data…",
      "add": "Add entry",
      "newTitle": "New data entry",
      "editTitle": "Edit “{{key}}”",
      "formDescription": "Values are plain text; agents often store JSON or Markdown here.",
      "key": "Key",
      "keyPlaceholder": "e.g. target_audience",
      "value": "Value",
      "valuePlaceholder": "Any text",
      "emptyValue": "(empty)",
      "chars": "{{n}} characters",
      "byRoom": "Written by task room #{{id}}",
      "saved": "“{{key}}” saved",
      "deleted": "“{{key}}” deleted",
      "delete": "Delete entry",
      "deleteTitle": "Delete “{{key}}”?",
      "deleteDescription": "Agents that rely on this value will no longer find it.",
      "empty": "No shared data yet",
      "emptyHint": "Agents write here as they work. You can also add entries yourself.",
      "noMatches": "No entries match your search"
    },
    "files": {
      "dropTitle": "Drop reference files here",
      "hint": "Agents can list and read these files. Documents are converted to text in the background.",
      "upload": "Upload files",
      "uploading_one": "Uploading {{count}} file…",
      "uploading_other": "Uploading {{count}} files…",
      "uploaded": "“{{name}}” uploaded",
      "duplicate": "“{{name}}” is already in this project",
      "deleted": "“{{name}}” deleted",
      "search": "Search files…",
      "download": "Download",
      "delete": "Delete file",
      "deleteTitle": "Delete “{{name}}”?",
      "deleteDescription": "Agents will no longer be able to read this file.",
      "empty": "No files uploaded yet.",
      "columns": {
        "name": "File",
        "size": "Size",
        "status": "Status",
        "uploaded": "Uploaded"
      },
      "status": {
        "ready": "Ready",
        "pending": "Processing",
        "failed": "Failed"
      },
      "kind": {
        "text": "Text",
        "document": "Document",
        "image": "Image"
      }
    },
    "knowledge": {
      "newDoc": "New document",
      "newDocIn": "New document in {{folder}}",
      "newFolder": "New folder",
      "createFolder": "Create folder",
      "folderPath": "Folder path",
      "folderPathHint": "Use slashes for nesting, e.g. research/notes.",
      "downloadAll": "Download all as zip",
      "search": "Search documents…",
      "noMatches": "No documents match your search.",
      "empty": "No documents yet",
      "emptyHint": "The knowledge base holds the project's specs, research and decisions. Agents search and update it while they work.",
      "select": "Select a document",
      "docTitle": "Title",
      "folder": "Folder",
      "folderHint": "Leave empty for the root.",
      "folderPlaceholder": "e.g. specs or research/notes",
      "content": "Content",
      "contentPlaceholder": "Write in Markdown…",
      "renameHint": "Changing the title or folder moves the document.",
      "updated": "Updated",
      "noContent": "This document is empty.",
      "delete": "Delete",
      "deleteTitle": "Delete “{{title}}”?",
      "deleteDescription": "The document is removed from the project's knowledge base.",
      "deleteFolder": "Delete folder {{path}}",
      "deleteFolderTitle": "Delete the empty folder “{{path}}”?",
      "saved": "“{{title}}” saved",
      "deleted": "“{{title}}” deleted",
      "folderCreated": "Folder “{{path}}” created",
      "folderDeleted": "Folder “{{path}}” deleted"
    },
    "orchestrator": {
      "name": "Orchestrator",
      "off": "Off",
      "status": {
        "idle": "Idle",
        "running": "Running",
        "awaiting_human": "Needs you",
        "done": "Done"
      },
      "trigger": {
        "manual": "Manual",
        "chat": "Message",
        "task_event": "Task update",
        "schedule": "Schedule"
      },
      "runPass": "Run a pass",
      "reset": "Reset",
      "resetTitle": "Reset the orchestrator?",
      "resetDescription": "Stops the running pass and clears its lock. Tasks already started keep running.",
      "resetDone": "Orchestrator reset",
      "settings": "Settings",
      "configure": "Configure",
      "setupTitle": "Set up the orchestrator",
      "setupDescription": "Enable the orchestrator and pick an agent to let it plan, create and start this project's tasks.",
      "notConfigured": "Enable the orchestrator and choose an agent first.",
      "idleHint": "Idle. Send a message or run a pass.",
      "awaitingHint": "Waiting for your input. Reply below to continue.",
      "doneHint": "The orchestrator considers the goal reached.",
      "working": "Working…",
      "workingOnTasks_one": "Working, {{count}} task in progress",
      "workingOnTasks_other": "Working, {{count}} tasks in progress",
      "thinking": "Thinking…",
      "reasoning": "Reasoning",
      "noSummary": "No summary for this pass.",
      "viewRun": "View run",
      "inProgress": "Tasks in progress",
      "reconnecting": "Reconnecting",
      "emptyTitle": "No conversation yet",
      "emptyDescription": "Tell the orchestrator what you want to achieve, or run a pass to let it plan from the goal.",
      "placeholder": "Message the orchestrator…",
      "send": "Send",
      "queueHint": "Messages sent while a pass is running are picked up by the next pass.",
      "coalesced": "A pass is already running; your request was queued for the next one.",
      "skipped": "Nothing to do right now; the pass was skipped.",
      "saved": "Orchestrator settings saved",
      "settingsTitle": "Orchestrator settings",
      "settingsDescription": "One agent plans, creates and starts all tasks of this project.",
      "enable": "Enable orchestrator",
      "enableHint": "While enabled the orchestrator is the only one that starts tasks; auto-start of follow-ups is ignored.",
      "agent": "Orchestrator agent",
      "agentHint": "The agent's instructions become the orchestrator's persona.",
      "agentNone": "No agent",
      "agentRequired": "Choose an agent to enable the orchestrator",
      "goal": "Goal",
      "goalHint": "The outcome the orchestrator works towards.",
      "goalPlaceholder": "e.g. Plan, write and review the launch blog post",
      "budget": "Actions per pass",
      "budgetHint": "Maximum changes the orchestrator may make in one pass.",
      "interval": "Run every",
      "intervalHint": "Optional periodic pass (5 minutes to 7 days). Leave empty to run only on events.",
      "intervalOff": "Only on events",
      "minutes": "min"
    }
  }
}
